import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-absence-overview',
  templateUrl: './user-absence-overview.component.html',
  styles: [
  ]
})
export class UserAbsenceOverviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
